module.exports = __webpack_public_path__ + "static/media/bts_lalela_170710_023_small.d0cc451f.jpg";